module.exports = __webpack_public_path__ + "static/media/S3_02.57b596e9.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/STAGE3strobe/S3_02.png
// module id = 196
// module chunks = 0